import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/clone': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M464 0c26.5 0 48 21.5 48 48v320c0 26.5-21.5 48-48 48h-48v48c0 26.5-21.5 48-48 48h-320c-26.5 0-48-21.5-48-48v-320c0-26.5 21.5-48 48-48h48v-48c0-26.5 21.5-48 48-48h320zM362 464c3.3 0 6-2.7 6-6v-42h-224c-26.5 0-48-21.5-48-48v-224h-42c-3.3 0-6 2.7-6 6v308c0 3.3 2.7 6 6 6h308zM458 368c3.3 0 6-2.7 6-6v-308c0-3.3-2.7-6-6-6h-308c-3.3 0-6 2.7-6 6v308c0 3.3 2.7 6 6 6h308z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/clone.js
// module id = 1711
// module chunks = 0